import React from 'react';
import { createDialog, DialogProps } from '../../../dialogs/dialogs';
import { nuiCtx } from '../../../../common/initialization';
import KycFormExtended from '../step_set_kyc_form/KycFormExtended';

const KycFormDialog = createDialog({
    name: 'kyc-form-dialog',
    component: ({ close, type, version }: { type: string; version: string } & DialogProps) => {
        const { NuiDialog } = nuiCtx.components;
        return (
            <NuiDialog mobileMode="DOCKED" name="kyc-form-dialog" className="kyc-form-dialog modal-sm" onClose={close}>
                <KycFormExtended type={type} version={version} />
            </NuiDialog>
        );
    }
});

export default KycFormDialog;
